import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f9193f2")

_pushScopeId("data-v-2f9193f2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("온라인 대면진료 신청 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, " 전문의를 선택하여 증상을 전송하면 대면진료 신청이 완료됩니다. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestQuick = _resolveComponent("RequestQuick")
  const _component_RequestNormal = _resolveComponent("RequestNormal")
  const _component_PageFrame = _resolveComponent("PageFrame")

  return (_openBlock(), _createBlock(_component_PageFrame, null, {
    title: _withId(() => [
      _hoisted_1
    ]),
    subtitle: _withId(() => [
      _hoisted_2
    ]),
    content: _withId(() => [
      _createVNode(_component_RequestQuick, {
        class: "quick",
        isContent: _ctx.state.pageType === _ctx.PageTypes.QUICK,
        hospitalKey: _ctx.state.selectedHospital,
        onClick: _ctx.selectQuick
      }, null, 8, ["isContent", "hospitalKey", "onClick"]),
      _createVNode(_component_RequestNormal, {
        isContent: _ctx.state.pageType === _ctx.PageTypes.NORMAL,
        onClick: _ctx.selectNormal,
        hospitalKey: _ctx.state.selectedHospital
      }, null, 8, ["isContent", "onClick", "hospitalKey"])
    ]),
    _: 1
  }))
})